// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1babc6de","513":"eca61b55","703":"63659926","787":"6c10fafb"}[chunkId] + ".chunk.js";
};